import * as angular from "angular";
import {IController} from "angular";

export class serviceProgressTooltipCtrl implements IController {

  serviceProgress: any;
  serviceType: any;

  private progressSteps: any;

  /* @ngInject */
  constructor(private deliveriesConstants) {
  }

  $onInit() {
  this.progressSteps = this.deliveriesConstants.serviceProgressSteps[this.serviceType];
  }
}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceProgressTooltip', {
    bindings: {
      serviceProgress: '<',
      serviceType: '<'
    },
    template: require('./service-progress-tooltip.html').default,
    controller: serviceProgressTooltipCtrl
  });
